<div class="sections">
    <div>
        <form [formGroup]="form">
            <div class="field">
                <h4>Business name</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <input matInput
                           formControlName="businessName"
                           autocomplete="off"
                           name="avoidSearch"
                           (focus)="activeExplanationChange('businessName', true)"
                           (focusout)="activeExplanationChange('businessName', false)"
                           enterkeyhint="next"
                    />
                    <mat-error *ngIf="formControlError(form, 'businessName') === 'required'">Business name is required</mat-error>
                </mat-form-field>
            </div>
            <div class="field">
                <h4>Ownership type</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="trigger-area" (click)="ownershipTypeAutocomplete.isOpen ? ownershipTypeTrigger.closePanel() : ownershipTypeTrigger.openPanel()"></div>
                        <input matInput #ownershipTypeInput
                               [matAutocomplete]="ownershipTypeAutocomplete"
                               #ownershipTypeTrigger="matAutocompleteTrigger"
                               [anchorAutocompleteOnScroll]="ownershipTypeTrigger"
                               formControlName="ownershipType"
                               autocomplete="off"
                               name="avoidSearch"
                               (focus)="ownershipTypeInput.blur()"
                               enterkeyhint="next"
                        >
                        <mat-icon matSuffix class="rotate" [class.do]="ownershipTypeAutocomplete.isOpen">expand_more</mat-icon>
                    </div>
                    <mat-autocomplete #ownershipTypeAutocomplete="matAutocomplete"
                                      (opened)="activeExplanationChange('ownershipType', true)"
                                      (closed)="activeExplanationChange('ownershipType', false)"
                    >
                        <mat-option value="Sole proprietorship">
                            Sole proprietorship
                        </mat-option>
                        <mat-option value="Corporation">
                            Corporation
                        </mat-option>
                        <mat-option value="LLC (Limited Liability Company)">
                            LLC (Limited Liability Company)
                        </mat-option>
                        <mat-option value="Partnership">
                            Partnership
                        </mat-option>
                        <mat-option value="Not for profit">
                            Not for profit
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="formControlError(form, 'ownershipType') === 'required'">Ownership type is required</mat-error>
                </mat-form-field>
            </div>
            <div class="field multiple">
                <div class="flex-fill">
                    <div class="d-flex justify-content-between align-items-center">
                        <h4>Address</h4>
                        <h4 class="simple-text-button" (click)="clearAddress()" *ngIf="form.controls.address.value !== null">Clear</h4>
                    </div>
                    <address-form-field
                        formControlName="address"
                        placeholder="Enter at least 7 characters for autocomplete"
                        [error]="addressError(form, 'address')"
                        (onFocus)="activeExplanationChange('address', $event)"
                    ></address-form-field>
                </div>
                <div style="width: 150px">
                    <h4>Unit</h4>
                    <mat-form-field appearance="outline" appFormFieldFilled>
                        <input matInput
                               formControlName="unit"
                               autocomplete="off"
                               name="avoidSearch"
                               (focus)="activeExplanationChange('unit', true)"
                               (focusout)="activeExplanationChange('unit', false)"
                               enterkeyhint="next"
                        />
                    </mat-form-field>
                </div>
            </div>
            <div class="field">
                <h4>Mailing address</h4>
                <div class="form-checkbox">
                    <mat-checkbox formControlName="mailingAddressSameAsAddress" color="primary"></mat-checkbox>
                    <p>Same as business address</p>
                </div>
                <ng-container *ngIf="showOptionalField('mailingAddressSameAsAddress')">
                    <div class="field multiple">
                        <div class="flex-fill">
                            <address-form-field
                                    formControlName="mailingAddress"
                                    placeholder="Enter at least 7 characters for autocomplete"
                                    [error]="addressError(form, 'mailingAddress', 'Mailing address')"
                                    (onFocus)="activeExplanationChange('mailingAddress', $event)"
                            ></address-form-field>
                        </div>
                        <div style="width: 150px">
                            <h4>Unit</h4>
                            <mat-form-field appearance="outline" appFormFieldFilled>
                                <input matInput
                                       formControlName="mailingAddressUnit"
                                       autocomplete="off"
                                       name="avoidSearch"
                                       (focus)="activeExplanationChange('mailingAddressUnit', true)"
                                       (focusout)="activeExplanationChange('mailingAddressUnit', false)"
                                       enterkeyhint="next"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div class="field">
                <h4>Mailing attention</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <input matInput
                           formControlName="mailingAttention"
                           autocomplete="off"
                           name="avoidSearch"
                           (focus)="activeExplanationChange('mailingAttention', true)"
                           (focusout)="activeExplanationChange('mailingAttention', false)"
                           enterkeyhint="next"
                    />
                </mat-form-field>
            </div>
            <div class="field">
                <h4>Business phone number</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <input matInput
                           formControlName="businessPhoneNumber"
                           autocomplete="off"
                           name="avoidSearch"
                           (focus)="activeExplanationChange('businessPhoneNumber', true)"
                           (focusout)="activeExplanationChange('businessPhoneNumber', false)"
                           enterkeyhint="next"
                           inputmode="tel"
                           mask="(000) 000-0000"
                    />
                    <mat-error *ngIf="formControlError(form, 'businessPhoneNumber') === 'required'">Business phone number is required</mat-error>
                    <mat-error *ngIf="formControlError(form, 'businessPhoneNumber') === 'invalid'">Invalid phone number</mat-error>
                </mat-form-field>
            </div>
            <div class="field">
                <h4>Support phone number</h4>
                <div class="form-checkbox">
                    <mat-checkbox formControlName="supportPhoneNumberSameAsBusinessPhoneNumber" color="primary"></mat-checkbox>
                    <p>Same as business phone number</p>
                </div>
                <ng-container *ngIf="showOptionalField('supportPhoneNumberSameAsBusinessPhoneNumber')">
                    <mat-form-field appearance="outline" appFormFieldFilled>
                        <input matInput
                               formControlName="supportPhoneNumber"
                               autocomplete="off"
                               name="avoidSearch"
                               (focus)="activeExplanationChange('supportPhoneNumber', true)"
                               (focusout)="activeExplanationChange('supportPhoneNumber', false)"
                               enterkeyhint="next"
                               inputmode="tel"
                               mask="(000) 000-0000"
                        />
                        <mat-error *ngIf="formControlError(form, 'supportPhoneNumber') === 'required'">Support phone number is required</mat-error>
                        <mat-error *ngIf="formControlError(form, 'supportPhoneNumber') === 'invalid'">Invalid phone number</mat-error>
                    </mat-form-field>
                </ng-container>
            </div>
            <div class="field">
                <h4>Contact phone number</h4>
                <div class="form-checkbox">
                    <mat-checkbox formControlName="contactPhoneNumberSameAsBusinessPhoneNumber" color="primary"></mat-checkbox>
                    <p>Same as business phone number</p>
                </div>
                <ng-container *ngIf="showOptionalField('contactPhoneNumberSameAsBusinessPhoneNumber')">
                    <mat-form-field appearance="outline" appFormFieldFilled>
                        <input matInput
                               formControlName="contactPhoneNumber"
                               autocomplete="off"
                               name="avoidSearch"
                               (focus)="activeExplanationChange('contactPhoneNumber', true)"
                               (focusout)="activeExplanationChange('contactPhoneNumber', false)"
                               enterkeyhint="next"
                               inputmode="tel"
                               mask="(000) 000-0000"
                        />
                        <mat-error *ngIf="formControlError(form, 'contactPhoneNumber') === 'required'">Contact phone number is required</mat-error>
                        <mat-error *ngIf="formControlError(form, 'contactPhoneNumber') === 'invalid'">Invalid phone number</mat-error>
                    </mat-form-field>
                </ng-container>
            </div>
            <div class="field">
                <h4>Mobile phone number</h4>
                <div class="form-checkbox">
                    <mat-checkbox formControlName="mobilePhoneNumberSameAsBusinessPhoneNumber" color="primary"></mat-checkbox>
                    <p>Same as business phone number</p>
                </div>
                <ng-container *ngIf="showOptionalField('mobilePhoneNumberSameAsBusinessPhoneNumber')">
                    <mat-form-field appearance="outline" appFormFieldFilled>
                        <input matInput
                               formControlName="mobilePhoneNumber"
                               autocomplete="off"
                               name="avoidSearch"
                               (focus)="activeExplanationChange('mobilePhoneNumber', true)"
                               (focusout)="activeExplanationChange('mobilePhoneNumber', false)"
                               enterkeyhint="next"
                               inputmode="tel"
                               mask="(000) 000-0000"
                        />
                        <mat-error *ngIf="formControlError(form, 'mobilePhoneNumber') === 'required'">Mobile phone number is required</mat-error>
                        <mat-error *ngIf="formControlError(form, 'mobilePhoneNumber') === 'invalid'">Invalid phone number</mat-error>
                    </mat-form-field>
                </ng-container>
            </div><div class="field">
            <h4>Business email address</h4>
            <mat-form-field appearance="outline" appFormFieldFilled>
                <input matInput
                       formControlName="businessEmail"
                       autocomplete="off"
                       name="avoidSearch"
                       (focus)="activeExplanationChange('businessEmail', true)"
                       (focusout)="activeExplanationChange('businessEmail', false)"
                       enterkeyhint="next"
                />
                <mat-error *ngIf="formControlError(form, 'businessEmail') === 'required'">Business email address is required</mat-error>
                <mat-error *ngIf="formControlError(form, 'businessEmail') === 'invalid'">Invalid email</mat-error>
            </mat-form-field>
        </div>
            <div class="field">
                <h4>Contact email address</h4>
                <div class="form-checkbox">
                    <mat-checkbox formControlName="contactEmailSameAsBusinessEmail" color="primary"></mat-checkbox>
                    <p>Same as business email address</p>
                </div>
                <ng-container *ngIf="showOptionalField('contactEmailSameAsBusinessEmail')">
                    <mat-form-field appearance="outline" appFormFieldFilled>
                        <input matInput
                               formControlName="contactEmail"
                               autocomplete="off"
                               name="avoidSearch"
                               (focus)="activeExplanationChange('contactEmail', true)"
                               (focusout)="activeExplanationChange('contactEmail', false)"
                               enterkeyhint="next"
                        />
                        <mat-error *ngIf="formControlError(form, 'contactEmail') === 'required'">Contact email address is required</mat-error>
                        <mat-error *ngIf="formControlError(form, 'contactEmail') === 'invalid'">Invalid email</mat-error>
                    </mat-form-field>
                </ng-container>
            </div>
            <div class="field">
                <h4>Business creation date</h4>
                <mat-form-field appearance="outline"
                                class="date-input"
                                appFormFieldFilled
                                (click)="datePicker.open()"
                >
                    <img class="img-calendar" matPrefix
                         src="../../../assets/icons/calendar.svg"
                         width="16" height="16">
                    <input #dateInput
                           matInput
                           formControlName="creationDate"
                           placeholder="MM/DD/YYYY"
                           inputmode="numeric"
                           [matDatepicker]="datePicker"
                           autocomplete="off"
                           name="avoidSearch"
                           enterkeyhint="next"
                           (focus)="activeExplanationChange('creationDate', true)"
                           (focusout)="activeExplanationChange('creationDate', false); fixDate('creationDate', form)"
                           (input)="maskInput($event, form.controls['creationDate'], '00/00/0000')"
                    >
                    <mat-datepicker #datePicker
                                    [disabled]="false"
                                    (opened)="activeExplanationChange('creationDatePicker', true)"
                                    (closed)="activeExplanationChange('creationDatePicker', false)"
                    ></mat-datepicker>
                    <mat-error *ngIf="formControlError(form, 'creationDate') === 'required'">Creation date is required</mat-error>
                    <mat-error *ngIf="formControlError(form, 'creationDate') === 'matDatepickerParse'">Invalid date</mat-error>
                    <mat-error *ngIf="formControlError(form, 'creationDate') === 'future'">Choose a date in the past</mat-error>
                </mat-form-field>
            </div>
            <div class="field">
                <h4>Federal tax ID</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <input matInput
                           formControlName="federalTaxID"
                           autocomplete="off"
                           name="avoidSearch"
                           (focus)="activeExplanationChange('federalTaxID', true)"
                           (focusout)="fixDashedNumber('federalTaxID', form); activeExplanationChange('federalTaxID', false)"
                           (keydown)="digitsAndDash($event)"
                           (paste)="onDigitsAndDashPaste($event)"
                           enterkeyhint="next"
                    />
                    <mat-error *ngIf="formControlError(form, 'federalTaxID') === 'required'">Federal tax ID is required</mat-error>
                    <mat-error *ngIf="formControlError(form, 'federalTaxID') === 'digitCount'">Must be exactly 9 digits</mat-error>
                </mat-form-field>
            </div>
            <div class="field">
                <h4>Current payment processor (Optional)</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <input matInput
                           formControlName="currentPaymentProcessor"
                           autocomplete="off"
                           name="avoidSearch"
                           (focus)="activeExplanationChange('currentPaymentProcessor', true)"
                           (focusout)="activeExplanationChange('currentPaymentProcessor', false)"
                           enterkeyhint="next"
                    />
                </mat-form-field>
            </div>

        </form>

        <div class="actions">
            <button mat-flat-button color="primary" (click)="nextClick.emit()">{{ (progress === 100) ? 'Finalize' : 'Next' }}</button>
        </div>
    </div>

    <div class="divider"></div>

    <div>
        <div class="info" #containerDiv>
            <div class="background" #backgroundDiv [ngStyle]="bgStyles"></div>

            <div class="field-explanation" #itemDiv [class.active]="activeIndex === i" *ngFor="let explanation of fieldExplanations; let i = index" [id]="'nuvei_app_' + explanation.id">
                <p>{{ explanation.title }}</p>
                <h4>{{ explanation.explanation }}</h4>
            </div>
        </div>
    </div>
</div>